import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {WalletsSelectComponent} from './wallets-select.component';
import {CustomSelectModule} from '../custom-select/custom-select.module';

@NgModule({
    declarations: [
        WalletsSelectComponent
    ],
    imports: [
        CommonModule,
        CustomSelectModule,
        MatProgressSpinnerModule
    ],
    exports: [
        WalletsSelectComponent
    ]
})
export class WalletsSelectModule {
}
